angular.
module("digiexam.components").
directive("group", function groupDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {draggable: "@", editable: "@", course: "=", isgroup: "@", group: "="},
		templateUrl: "directives/group.html",
		replace: true,
		link: function link($scope, element) {
			if (!$scope.group.externallyManaged && $scope.group.integrationSource === 0) {
				element.draggable({
					revert: true,
					revertDuration: 0,
					cursorAt: {left: 9, top: 15},
					zIndex: 20,
					cancel: false,
					helper: function helper() {
						var $el = angular.element("<div />").addClass("group dragging-helper");

						$el.data("title", $scope.group.title);
						$el.data("id", $scope.group.id);

						return $el;
					},

					start: function start() {
						return angular.element(this).attr("draggable");
					},
				});
			}
		},

		controller: function controller($scope, $rootScope, $location, dxSession, RoleTypeEnum) {
			$scope.click = function click() {
				if (dxSession.getRole().roleType === RoleTypeEnum.STUDENT) {
					return;
				}

				var path = "/class/" + $scope.group.id;

				if (typeof $scope.editable !== "undefined" && $scope.editable) {
					path += "/edit";
				} else {
					path += "/view";
				}

				if ($scope.course) {
					path += "/" + $scope.course.id;
				}

				$location.path(path);
			};
		},
	};
});
